export default __webpack_public_path__ + "static/media/whatsapp-icon.c32f1065.svg";